<template>
  <div class="spinnerInput">
    <div>
      <!--<div>-->
        <!--<mu-icon-button icon-class="blueIcon" icon="keyboard_arrow_up" @click.native="increment"></mu-icon-button>-->
      <!--</div>-->
      <div>
        <mu-icon :size="21" :value="icon"></mu-icon>
        <span class="numberMiddle">{{numberValue}}</span>
      </div>
      <!--<div>-->
        <!--<mu-icon-button icon-class="blueIcon" icon="keyboard_arrow_down" @click.native="decrement"></mu-icon-button>-->
      <!--</div>-->
    </div>
  </div>
</template>
<script>
  export default {
    name: "number-spinner",
    props: ['value', 'mode', 'icon'],
    data() {
      return {
        numberValue: this.value
      }
    },
    mounted() {
      this.numberValue = this.value;
    },
    methods: {
      increment() {
        this.numberValue++;
        this.$emit('input', this.numberValue)
      },
      decrement() {
        if (this.numberValue !== 1) {
          this.numberValue--;
          this.$emit('input', this.numberValue)
        }
      }
    }
  }
</script>
<style>
  .spinnerInput {
    display: inline-block;
    text-align: center;
    font-size: 24px;
  }
</style>




// WEBPACK FOOTER //
// NumberSpinner.vue?c158b2c8